import React, { Component } from "react"
import Webcam from "./webcam"

class Post extends Component {
    render() {
        const { index } = this.props
        //const scale = 1 - (index * 0.20)
        //const scale = 1 - (index * 0.27)
        const scale = 1 - index * 0.07
        //console.log(index, scale)
        const style = {
            zIndex: index,
            transform: "translate(-50%, -50%) scale(" + scale + ")",
        }
        return (
            <div className="post" style={style}>
                <div className="header" />
                <div className="me">
                    <Webcam videoID={"web-cam-" + index} />
                </div>
                <div className="footer" />
            </div>
        )
    }
}

export default Post
